import React from 'react';
import {Redirect, Route} from "react-router-dom";
import {RouteComponentProps, StaticContext} from "react-router";
import {useSelector} from "react-redux";
import {StateType} from "../store/store";

type RouteProps = {
  [x: string]: any,
  component: React.ComponentType<any> | React.ComponentType<RouteComponentProps<any, StaticContext, unknown>>
}

export default function AdminPrivateRoute({component: Component, ...rest}: RouteProps) {
  const studentState = useSelector((state: StateType) => state.rootReducer.adminReducer);
  const {data} = studentState;
  return (
    <Route
      {...rest}
      render={(props =>
          data.role === "admin" ? (
            <Component {...props} />
          ) : (
            <Redirect to={{pathname: "/admin/login"}}/>
          )
      )}
    />
  )
}